import { useRecoilState } from "recoil";
import { useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import { info as myInfo } from "../../store/my";
import { project as portfolioProject } from "../../store/portfolio";

export default function Portfolio() {

    const [useMyInfo, setMyInfo] = useRecoilState(myInfo);
    const [usePortfolioProject, setPortfolioProject] = useRecoilState(portfolioProject);

    return (
        <div className="section portfolio wf-section">
            <div className="container-default w-container">
                <div className="portfolio-title-wrapper"><h1 className="title portfolio">Portfolio</h1></div>
                <div className="w-dyn-list">
                    {/* Desktop Masonry - Split Columns for Ordered Look */}
                    <div className="desktop-masonry w-hidden-medium w-hidden-small w-hidden-tiny" style={{ display: 'flex', gap: '40px' }}>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '40px' }}>
                            {
                                Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).filter((_, i) => i % 2 === 0).map(item => (
                                    <div role="listitem" className="w-dyn-item" key={item}>
                                        <Link to={'/project/' + item}
                                            className="card portfolio-project w-inline-block" style={{ marginBottom: 0 }}>
                                            <div className="image-wrapper portfolio-project"><img
                                                src={usePortfolioProject[item].logo}
                                                alt="" className="image portfolio-project" />
                                            </div>
                                            <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                            <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                            <p>{usePortfolioProject[item].description}</p>
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '40px' }}>
                            {
                                Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).filter((_, i) => i % 2 !== 0).map(item => (
                                    <div role="listitem" className="w-dyn-item" key={item}>
                                        <Link to={'/project/' + item}
                                            className="card portfolio-project w-inline-block" style={{ marginBottom: 0 }}>
                                            <div className="image-wrapper portfolio-project"><img
                                                src={usePortfolioProject[item].logo}
                                                alt="" className="image portfolio-project" />
                                            </div>
                                            <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                            <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                            <p>{usePortfolioProject[item].description}</p>
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    {/* Mobile List - Standard Grid/List */}
                    <div role="list" className="portfolio-grid w-dyn-items w-hidden-main">
                        {
                            Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).map(item => (
                                <div role="listitem" className="w-dyn-item" key={item}>
                                    <Link to={'/project/' + item}
                                        className="card portfolio-project w-inline-block">
                                        <div className="image-wrapper portfolio-project"><img
                                            src={usePortfolioProject[item].logo}
                                            alt="" className="image portfolio-project" />
                                        </div>
                                        <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                        <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                        <p>{usePortfolioProject[item].description}</p>
                                    </Link>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}